import React, { useState, useEffect, lazy, Suspense } from "react";
import newsData from "../Data/news.js";
import defaultImage from "../../assets/Latest.jpg";
import YouTubeImg from "../../assets/shapes/youtube-svgrepo-com.svg";

// Lazy-load react-slick
const Slider = lazy(() => import("react-slick"));

export default function LatestNews() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    setNews(newsData);
  }, []);

  const getYouTubeId = (url) => {
    const regExp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|embed)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };

  const settings = {
    infinite: true,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div
      className="latest-news-carousel"
      style={{ backgroundColor: "#f4f3f8", padding: "30px" }}
    >
      <h2
        className="text-center mb-5"
        style={{ color: "#f9313b", fontWeight: 600 }}
      >
        Latest News
      </h2>

      <Suspense fallback={<div>Loading carousel...</div>}>
        <Slider {...settings}>
          {news.map((item, index) => (
            <div
              key={index}
              className="card mx-2"
              style={{ width: "90%", height: "400px", borderRadius: "10px" }}
            >
              {item.video ? (
                <div
                  className="video-facade"
                  onClick={(e) => {
                    const videoId = getYouTubeId(item.video);
                    e.currentTarget.outerHTML = `<iframe width="100%" height="195" src="https://www.youtube.com/embed/${videoId}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="border-radius: 3px 3px 10px 10px;"></iframe>`;
                  }}
                  style={{
                    height: "195px",
                    backgroundColor: "#000",
                    position: "relative",
                    borderRadius: "3px 3px 10px 10px",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={`https://img.youtube.com/vi/${getYouTubeId(
                      item.video
                    )}/hqdefault.jpg`}
                    alt={item.title || "Video thumbnail"}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "inherit",
                    }}
                    loading="lazy"
                    width="100%"
                    height="195"
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      padding: "12px",
                    }}
                  >
                    <img
                      src={YouTubeImg}
                      alt="Play YouTube"
                      style={{
                        width: "50px",
                        height: "50px",
                        filter: "drop-shadow(0 0 4px rgba(255, 255, 255, 0.5))",
                      }}
                    />
                  </div>
                </div>
              ) : (
                <img
                  src={item.image || defaultImage}
                  className="card-img-top"
                  alt={item.title || "News Image"}
                  style={{
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "3px 3px 10px 10px",
                  }}
                  loading="lazy"
                  width="100%"
                  height="200"
                />
              )}
              <div
                className="card-body text-center"
                style={{ overflow: "hidden", height: "calc(100% - 200px)" }}
              >
                <h5
                  className="card-title text-primary"
                  style={{ fontSize: "1rem" }}
                >
                  {item.title || "Untitled News"}
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{
                    fontSize: "0.9rem",
                    height: "60px",
                    overflow: "hidden",
                  }}
                >
                  {item.description || "No description available."}
                </p>
                {item.link && (
                  <a
                    href={item.link}
                    className="btn btn-danger"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Know More
                  </a>
                )}
              </div>
            </div>
          ))}
        </Slider>
      </Suspense>
    </div>
  );
}
